module.exports = __webpack_public_path__ + "img/message-smile-circle.97690ef3.svg";